import React, { useMemo } from 'react';
import styled from 'styled-components';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { palette } from '@solvhealth/jigsaw-v1';
import { colors } from '~/constants/colors';
import { fontFamily, fontSize } from '~/constants/text';
import { smallerThan } from '~/core/util/styledComponents';
import {
  getRemixSrpSearchObject,
  ServiceForSearch,
} from '~/components/Home/ServicesSection/services';
import { analyticsTrackEvent } from '~/core/analytics';
import { ACTION_CLICK_SELF_PAY_SERVICE_TILE, HOMEPAGE } from '~/core/analytics/events';
import { RemixRoutes } from '~/core/remix';

const Tag = styled.button.withConfig({ componentId: 'sc-g7i406-0' })`
  appearance: none;
  border: none;
  background: ${palette.egg};
  color: ${colors.darkText};
  padding: 16px 24px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  border-radius: 104px;
  font-family: ${fontFamily.medium};
  transition: background 0.15s;
  font-size: ${fontSize.default};
  cursor: pointer;
  display: flex;
  align-items: center;

  ${smallerThan.tablet`
    font-size: ${fontSize.mediumSmall};
    padding: 8px 16px;
  `}
  &:focus {
    outline: none;
  }

  &:hover {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
  }
`;

const StyledChevronRight = styled(ChevronRight).withConfig({ componentId: 'sc-g7i406-1' })`
  color: ${palette.mint.base};
`;

type Props = {
  /** The service to display */
  service: ServiceForSearch;
};

/**
 * A small tag representing a single service or symptom
 */
const ServiceTag = ({ service }: Props) => {
  const url = useMemo(() => {
    const update = getRemixSrpSearchObject(service);
    return RemixRoutes.search.controlled(update);
  }, [service]);

  const onClick = () => {
    analyticsTrackEvent(HOMEPAGE, {
      action: ACTION_CLICK_SELF_PAY_SERVICE_TILE,
      tile: service.name,
    });

    if (service.onClick) {
      service.onClick();
      return;
    }
  };

  return (
    <a href={url} onClick={onClick}>
      <Tag>
        {service.name} <StyledChevronRight />
      </Tag>
    </a>
  );
};

export default ServiceTag;
